import { cloneDeep as _cloneDeep } from 'lodash';
import moment from 'moment-timezone';
import { fieldTypes } from 'components/utils/validator';
import { contributorObject } from './contributorObject';
let isRequired = true;
let isOptional = false;

export const acctObject = {
  name: fieldTypes.Text(null , 'Account Name', isRequired, '', { minLen: 5, maxLen: 50 }),
  desc: fieldTypes.Text(null, 'Short Description', isOptional, '', { maxLen: 100 }),
  code: fieldTypes.Text(null, 'Account Short Code', isOptional, 'CHIT_CODE', { minLen: 5, maxLen: 32, noSpaces: true, accountCode: true }),
  curr: fieldTypes.Text(null, 'Currency', isRequired, 'INR'),
  type: fieldTypes.Text(null, 'Account Type', isRequired, 'CHIT'),
  status: fieldTypes.Text(null, 'Status', isRequired, 'ac'),
  date: fieldTypes.Date(null, 'Start Date'),
  url: fieldTypes.Text(null, 'URL', isOptional, '', {isURL: true})
};

export const mapAccount = (_account) => {
  let sub = _cloneDeep(acctObject);
  if (!_account) {
      return sub;
  }
  let {code, curr, date, name, status, type, desc, url, chit_info} = _account;
  if (code) sub.code.value = code;
  if (curr) sub.curr.value = curr;
  sub.date.value = (date) ? date.substr(0,10) : moment().format('YYYY-MM-DD');
  if (name) sub.name.value = name;
  if (desc || desc === '') sub.desc.value = desc;
  if (status) sub.status.value = status;
  if (type) sub.type.value = type;
  if (url) sub.url.value = url;
  // no mapped values; simple object, if any
  if (chit_info) sub.chit_info = chit_info;
  return sub;
}

export const unmapAccount = (_accountMap) => {
  let {code, curr, date, name, status, type, desc, url, chit_info} = _accountMap;
  let acc = {};
  if (code) acc.code = code.value;
  if (curr) acc.curr = curr.value;
  if (date) acc.date = date.value;
  if (name) acc.name = name.value;
  if (desc) acc.desc = desc.value;
  if (status) acc.status = status.value;
  if (type) acc.type = type.value;
  if (url) acc.url = url.value;
  // no mapped values; simple object, if any
  if (chit_info) acc.chit_info = chit_info;
  return acc;
}

export const subscriberObject = {
  fname: fieldTypes.Text(null , 'First Name', isRequired, '', { minLen: 3, maxLen: 50 }),
  lname: fieldTypes.Text(null , 'Last Name', isRequired, '', { minLen: 1, maxLen: 50 }),
  desc: fieldTypes.Text(null, 'Description', isOptional, '', { maxLen: 100 }),
  country: fieldTypes.Text(null , 'Country', isRequired, 'IN', { len: 2 }),
  state: fieldTypes.Text(null , 'State', isRequired, 'TN', { len: 2 }),
  cell: fieldTypes.Text(null, 'Mobile', isRequired, '', { minLen: 10, maxLen: 10, noSpaces: true, isNumber: true }),
  email: fieldTypes.Text("txtFieldEmail", 'Email', isOptional, '', { noSpaces: true, isEmail: true }),
  curr: fieldTypes.Text(null, 'Currency', isRequired, 'INR'),
  status: fieldTypes.Text(null, 'Status', isRequired, 'ac'),
  date: fieldTypes.Date(null, 'Date')
};


export const mapSubscriber = (_sub) => {
  let sub = _cloneDeep(subscriberObject);
  if (!_sub) {
      return sub;
  }
  let {cell, email, curr, date, fname, lname, status, desc, country, state} = _sub;
  if (curr) sub.curr.value = curr;
  sub.date.value = (date) ? date.substr(0,10) : moment().format('YYYY-MM-DD');
  if (fname) sub.fname.value = fname;
  if (lname) sub.lname.value = lname;
  if (desc || desc === '') sub.desc.value = desc;
  if (status) sub.status.value = status;
  if (cell) sub.cell.value = cell;
  if (email) sub.email.value = email;
  if (country) sub.country.value = country;
  if (state) sub.state.value = state;
  return sub;
}


export const 
formatSubcriberName = (sub, includeCell=true) => {
    let {fname, lname, isd_code, cell} = sub;
    let name = '';
    if (fname && lname) name += `${fname} ${lname}`;
    else if (fname) name += fname;
    else if (lname) name += lname;
    if (includeCell) {
        let mobile = isd_code + cell;
        if (mobile) {
            name += (name ? ` (${mobile})` : mobile);
        }
    }
    return name;
}


export const acctChitObject = {
  chit_amount: fieldTypes.Number(null, 'Chit Amount', isOptional, 100000, { minNum: 1000, maxNum: 1000000 }),
  chit_tenure: fieldTypes.Number(null, 'No. Of Months', isOptional, 20, { minNum: 6, maxNum: 60 }),
  chit_subscribers: fieldTypes.Number(null, 'No. Of Members', isOptional, 20, { minNum: 6, maxNum: 60 }),
  chit_term_amount: fieldTypes.Number(null, 'EMI', isOptional, 5000, { minNum: 100, maxNum: 100000 }),
  chit_term_fee: fieldTypes.Number(null, 'FEE', isOptional, 1000, { minNum: 0, maxNum: 20000 }),
  chit_start_on: fieldTypes.Date(null, 'Chit Start Date'),
  chit_draw_date: fieldTypes.Number(null, 'Chit Day', isOptional, 15, { minNum: 1, maxNum: 28 }),
  chit_due: fieldTypes.Number(null, 'Due by', isOptional, 10, { minNum: 1, maxNum: 28 }),
  chit_commission: fieldTypes.Number(null, 'Commission', isOptional, 1000, { minNum: 0, maxNum: 20000 }),
};

export const mapAccountChit = (_accountChitInfo) => {
  // console.log('mapping _accountChitInfo', _accountChitInfo)
  let sub = _cloneDeep(acctChitObject);
  if (_accountChitInfo) {
      let {
          chit_amount,
          chit_tenure,
          chit_subscribers,
          chit_term_amount,
          chit_start_on,
          chit_term_fee,
          chit_draw_date,
          chit_due,
          chit_commission
      } = _accountChitInfo;
      sub.chit_amount.value = chit_amount || 0;
      sub.chit_tenure.value = chit_tenure || 0;
      sub.chit_subscribers.value = chit_subscribers || 0;
      sub.chit_term_amount.value = chit_term_amount || 0;
      sub.chit_start_on.value = chit_start_on;
      sub.chit_term_fee.value = chit_term_fee || 0;
      sub.chit_draw_date.value = chit_draw_date || 0;
      sub.chit_due.value = chit_due || 0;
      sub.chit_commission.value = chit_commission || 0;
  return sub;
  } else {
      return sub;
  }
}

export const unmapAccountChit = (_accountChitInfoMap) => {
  let {
      chit_amount,
      chit_tenure,
      chit_subscribers,
      chit_term_amount,
      chit_start_on,
      chit_term_fee,
      chit_draw_date,
      chit_due
  } = _accountChitInfoMap;
  let accChitInfo = {};
  if (chit_amount) accChitInfo.chit_amount = chit_amount.value;
  if (chit_tenure) accChitInfo.chit_tenure = chit_tenure.value;
  if (chit_subscribers) accChitInfo.chit_subscribers = chit_subscribers.value;
  if (chit_term_amount) accChitInfo.chit_term_amount = chit_term_amount.value;
  if (chit_start_on) accChitInfo.chit_start_on = chit_start_on.value;
  if (chit_term_fee) accChitInfo.chit_term_fee = chit_term_fee.value;
  if (chit_draw_date) accChitInfo.chit_draw_date = chit_draw_date.value;
  if (chit_due) accChitInfo.chit_due = chit_due.value;
  return accChitInfo;
}




export const chitTermObject = {
  chit_amount: fieldTypes.Number(null, 'Chit Fund Amount', isOptional, 100000, { minNum: 1000, maxNum: 1000000 }),
  chit_tenure: fieldTypes.Number(null, 'Chit Fund Tenure', isOptional, 20, { minNum: 6, maxNum: 60 }),
  chit_subscribers: fieldTypes.Number(null, 'Chit Fund Subscribers', isOptional, 20, { minNum: 6, maxNum: 60 }),
  chit_term_amount: fieldTypes.Number(null, 'Chit Fund Term Amount (Before Awarding chit)', isOptional, 5000, { minNum: 100, maxNum: 100000 }),
  chit_term_fee: fieldTypes.Number(null, 'Chit Fund Term Fee (After Awarding chit)', isOptional, 1000, { minNum: 1, maxNum: 20000 }),
  chit_start_on: fieldTypes.Date(null, 'Chit Start Date', isOptional),
  chit_draw_date: fieldTypes.Number(null, 'Chit Term Day (day of the month)', isOptional, 1, { minNum: 1, maxNum: 28 }),
  chit_due: fieldTypes.Number(null, 'Chit Term Due (due day of the month)', isOptional, 5, { minNum: 1, maxNum: 28 }),
  chit_bidder: fieldTypes.Text(null, 'Who won the bidding (Lifting)?', isRequired)
};


export const accountCCStmtSummaryObject = {
  limit: fieldTypes.Amount('limit', 'Credit Limit', isRequired, 1000 ),
  available: fieldTypes.Amount('available', 'Available Credit', isRequired, 1000),
  last_statement_date: fieldTypes.Date('last_statement_date', 'Last Statement Date'),
  last_statement_due: fieldTypes.Date('last_statement_due', 'Due On', isOptional, moment().add(45, 'days').format('YYYY-MM-DD')),
  last_statement_min: fieldTypes.Amount('last_statement_min', 'Minimum Due'),
  last_statement_bal: fieldTypes.Amount('last_statement_bal', 'Total Due'),
  last_payment_date: fieldTypes.Date('last_payment_date', 'Last Payment Date'),
  last_payment_amnt: fieldTypes.Amount('last_payment_amnt', 'Last Payment Amount')
}

export const accountCCStmtScheduleObj = {
  limit: fieldTypes.Amount('limit', 'Credit Limit', isRequired, 1000 ),
  available: fieldTypes.Amount('available', 'Available Credit', isRequired, 1000 ),
  stmt_start_date: fieldTypes.Date('stmt_start_date', 'Statement Start Date'),
  frequency: fieldTypes.List('frequency', 'Frequency', isRequired, 'monthly', { inList: [{
    code: 'monthly',
    name: 'Monthly',
    inc: 'Months',
    default: true
  },
  // {
  //   code: 'quarterly',
  //   name: 'Quarterly',
  //   inc: 'Quarters'
  // }
  ]} ),
  statement_day: fieldTypes.Number('statement_day', 'Statement Date (day of the month)', isRequired, 1, { minNum: 1, maxNum: 28 }),
  next_statement_date: fieldTypes.Date('next_statement_date', 'Next Statement Date', isRequired),
  due_grace_period: fieldTypes.Number('due_grace_period', 'Payment Due Grace Period (No. of days)', isRequired, 25, { minNum: 0, maxNum: 99 }),
  next_payment_due_date: fieldTypes.Date('next_payment_due_date', 'Next Payment Due Date', isRequired),
  pu_rate: fieldTypes.Percent('pu_rate', 'Purchases % (0.00)', isRequired, 24.00),
  ca_rate: fieldTypes.Percent('ca_rate', 'Cash Adv % (0.00)', isRequired, 24.00),
  bt_rate: fieldTypes.Percent('bt_rate', 'Bal Transfer % (0.00)', isRequired, 24.00),

  /** An annual percentage rate (APR) of 24% indicates that if you carry -
  |*   a balance on a credit card for a full year, the balance will increase -
  |*   by approximately 24% due to accrued interest. For instance, if you maintain -
  |*   a $1,000 balance throughout the year, the interest accrued would amount to -
  \*   around $240.00. **/
  apr_rate: fieldTypes.Percent('apr_rate', 'APR % (0.00)', isRequired, 24.00),

  // Annaul Fee
  annual_fee_flag: fieldTypes.Checkbox('annual_fee_flag', 'Annual Fee Flag', isRequired, true),
  annual_fee: fieldTypes.Amount('annual_fee', 'Annual Fee', isOptional, 49),
  annual_fee_on: fieldTypes.Date('annual_fee_on', 'Next Annual Fee Date')
}



export const mapAccountSchedule = (_accountScheduleInfo) => {
  let sub = _cloneDeep(accountCCStmtScheduleObj);
  if (_accountScheduleInfo) {
      let {
        limit,
        available,
        stmt_start_date,
        frequency,
        statement_day,
        next_statement_date,
        due_grace_period,
        next_payment_due_date,
        pu_rate,
        bt_rate,
        ca_rate,
        apr_rate,
        annual_fee_flag,
        annual_fee,
        annual_fee_on
      } = _accountScheduleInfo;
      sub.limit.value = limit;
			sub.available.value = available;
			sub.stmt_start_date.value = stmt_start_date;
			sub.frequency.value = frequency;
			sub.statement_day.value = statement_day;
			sub.next_statement_date.value = next_statement_date;
			sub.due_grace_period.value = due_grace_period;
			sub.next_payment_due_date.value = next_payment_due_date;
			sub.pu_rate.value = pu_rate;
			sub.bt_rate.value = bt_rate;
			sub.ca_rate.value = ca_rate;
			sub.apr_rate.value = apr_rate;
			sub.annual_fee_flag.value = annual_fee_flag;
      //override default value only if already entered.
      if (annual_fee_flag) {
        sub.annual_fee.value = annual_fee;
        sub.annual_fee_on.value = annual_fee_on;  
      }
      return sub;
  } else {
      return sub;
  }
}



export const mapMemberToContributor = (member) => {
  // console.log('member', member);
  let contributor = _cloneDeep(contributorObject);
  if (!member.email) return contributor;
  // try {
      let {name, email, role, status} = member;
      contributor.name.value = name;
      contributor.email.value = email;
      contributor.role.value = role;
      contributor.status.value = status;
  // } catch (error) {
  //     //
  // }
  // console.log('contributor', contributor);
  return contributor;
}
